export default __webpack_public_path__ + "assets/images/efaa17fe2c9c94b05180d1d62fe23011.svg";